<template>
  <div class="time-input">
    <input
      type="text"
      v-model="localHour"
      placeholder="--"
      @input="onHourChange"
      @blur="onHourBlur"
    />
    <span class="time-input-colon">:</span>
    <input
      type="text"
      v-model="localMinute"
      placeholder="--"
      @input="onMinuteChange"
      @blur="onMinuteBlur"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseTimeInput',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localHour: '',
      localMinute: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this._skipWatch) {
          this._skipWatch = false;
          return;
        }
        if (!val) {
          this.localHour = '';
          this.localMinute = '';
          return;
        }
        const [h, m] = val.split(':');
        this.localHour = h;
        this.localMinute = m;
      },
    },
  },
  created() {
    this._skipWatch = false;
  },
  methods: {
    sanitizeInput(val) {
      return val.replace(/\D/g, '').slice(0, 2);
    },
    onHourChange() {
      this.localHour = this.sanitizeInput(this.localHour);
      this.emitValue();
    },
    onHourBlur() {
      if (this.localHour === '') {
        return;
      }

      let h = Number(this.localHour);
      if (isNaN(h)) {
        return;
      }

      if (h < 0) {
        h = 0;
      }
      if (h > 24) {
        h = 24;
      }

      this.localHour = String(h).padStart(2, '0');

      if (h === 24) {
        this.localMinute = '00';
      }

      this.emitValue();
    },

    onMinuteChange() {
      this.localMinute = this.sanitizeInput(this.localMinute);
      this.emitValue();
    },

    onMinuteBlur() {
      if (this.localMinute === '') {
        return;
      }

      let m = Number(this.localMinute);
      if (isNaN(m)) {
        return;
      }

      const maxMin = Number(this.localHour) === 24 ? 0 : 59;

      if (m < 0) {
        m = 0;
      }
      if (m > maxMin) {
        m = maxMin;
      }

      this.localMinute = String(m).padStart(2, '0');
      this.emitValue();
    },

    emitValue() {
      this._skipWatch = true;
      if (this.localHour === '' || this.localMinute === '') {
        this.$emit('input', '');
        return;
      }

      this.$emit('input', `${this.localHour}:${this.localMinute}`);
    },
  },
};
</script>

<style scoped>
.time-input {
  display: inline-flex;
  align-items: center;
}
.time-input input:focus {
  outline: 0;
  background: #f1f3f8;
  border: 1px solid #3d5ccc;
  -webkit-box-shadow: 0px 0px 2px #3d5ccc;
  box-shadow: 0px 0px 2px #3d5ccc;
}

.time-input input {
  width: 60px;
  text-align: center;
  height: 36px;
  border: 1px solid #aaaebb;
  border-radius: 5px;
}

.time-input-colon {
  margin: 0px 5px 0px 5px;
}

/* スピナー削除（Chrome系） */
.time-input input::-webkit-outer-spin-button,
.time-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.time-input input::placeholder {
  color: #000;
  opacity: 1; /* Firefoxはデフォルトでopacityが下がるため*/
  font-weight: bold;
}
</style>
